/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ChromeWrapperRendererQueryVariables = {};
export type ChromeWrapperRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ChromeWrapper_viewer">;
    };
};
export type ChromeWrapperRendererQuery = {
    readonly response: ChromeWrapperRendererQueryResponse;
    readonly variables: ChromeWrapperRendererQueryVariables;
};



/*
query ChromeWrapperRendererQuery {
  viewer {
    ...ChromeWrapper_viewer
    id
  }
}

fragment AutopilotFlexibility_org on Org {
  userWorkingHours(resolveOverrides: false) {
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
    id
  }
}

fragment AutopilotForm_org on Org {
  ...AutopilotFlexibility_org
  ...OrganizerAutopilotPausedFreemiumCallout_org
  id
  experiments
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  pendingInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment ChromeCreateEvent_org_2evVr4 on Org {
  ...AutopilotForm_org
  id
  domains
  primaryOrgCalendar
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isOutsideOrg
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment ChromeLogin_viewer on Viewer {
  ...LoginBtn_viewer
  user {
    id
  }
}

fragment ChromeMenuDrawer_viewer on Viewer {
  user {
    id
    emails
    givenName
    familyName
    externalImageUrl
    dataSources(first: 1000000) {
      edges {
        node {
          id
          status
          name
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          id
          domains
          personForUserErrorable {
            __typename
            ... on GraphEntityError {
              message
            }
            ... on Person {
              id
              primaryEmail
              emails
              isYou
              userId
              isUser
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          slackAccountsErrorable {
            __typename
            ... on SlackAccountList {
              list {
                id
                slackTeamId
                slackUserId
                teamDisplayName
              }
            }
            ... on GraphEntityError {
              message
              statusCode
            }
          }
          eventColoringSettingsErrorable {
            __typename
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on EventColoringSettings {
              eventCategoryColorings {
                googleColorKey
                eventCategory
                active
                isUserSet
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          primaryTeam {
            __typename
            ... on Team {
              teamId
            }
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          featureGrid {
            __typename
            ... on FeatureGrid {
              stateMetadata {
                primaryBillingGroupMetadata {
                  subscription {
                    id
                    type
                    productType
                  }
                }
              }
            }
            ... on GraphEntityError {
              statusCode
              message
            }
          }
        }
      }
    }
  }
}

fragment ChromePersonalCalendar_org on Org {
  id
  domains
}

fragment ChromePersonalCalendar_user on User {
  dataSources(first: 1000000) {
    edges {
      node {
        id
        state
        type
        name
        syncTargets {
          emailAddress
          calendarId
        }
      }
    }
  }
}

fragment ChromeWrapper_viewer on Viewer {
  ...ChromeLogin_viewer
  ...ChromeMenuDrawer_viewer
  user {
    ...ChromePersonalCalendar_user
    ...TutorialBox_user
    ...FeedScheduler_user
    id
    status
    emails
    givenName
    familyName
    createdTime
    linkNameErrorable {
      __typename
      ... on GraphEntityError {
        message
        statusCode
      }
      ... on LinkName {
        __typename
        linkName
      }
    }
    schedulingLinks {
      linkName
      linkUrl
      meetingSettings {
        id
        timingSettings {
          durationMinutes
          timeRange {
            windowSizeDays
          }
        }
        name
        slug
        isActive
        availabilityType
      }
    }
    members {
      value
      scope {
        type
        value
        id
      }
      id
    }
    webAppFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    chromeExtensionFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    flowStates(first: 1000000) {
      edges {
        node {
          ...FastCrawlLoader_flowState
          ...FlowStatePoller_flowState
          id
          flowKey
          previousState
          current {
            state
            percentComplete
            errorMessage
            id
          }
          pending {
            state
            percentComplete
            errorMessage
            id
          }
        }
      }
    }
    dataSources(first: 1000000) {
      edges {
        node {
          id
          state
          type
          name
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          ...OnboardingNUXRenderer_org
          ...ChromePersonalCalendar_org
          ...FastCrawlErrorCard_org
          ...FeedScheduler_org
          ...PricingDialog_org
          ...FreemiumStatusCallout_org
          ...ChromeCreateEvent_org_2evVr4
          ...PlanStatusRefetch_org
          id
          name
          domains
          createdTime
          crawlTest
          featureGrid {
            __typename
            ... on FeatureGrid {
              stateMetadata {
                userMetadata {
                  person {
                    primaryCalendarId
                    id
                  }
                  trialMetadata {
                    trialEndDate
                    timeZone
                  }
                }
              }
            }
            ... on GraphEntityError {
              statusCode
              message
            }
          }
          experiments
          primaryOrgEmail
          primaryOrgCalendar
          userWorkingHours(resolveOverrides: false) {
            workingHours {
              id
              type
              timeZone
              daySettings {
                day
                setting {
                  minSlot
                  maxSlot
                  excludedSlots
                }
              }
              dayOverrides {
                date
                setting {
                  minSlot
                  maxSlot
                  excludedSlots
                }
              }
            }
            id
          }
          orgMeetingHours {
            workingHours {
              timeZone
              id
            }
            id
          }
          shadowCalendarSettingsErrorable {
            __typename
            ... on ShadowCalendarSettings {
              enabled
              shadowCalendarId
              focusTimeIdealMinutesPerWeek
              focusTimeSyncEnabled
              focusTimeSyncAll
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          flowStates(first: 1000000) {
            edges {
              node {
                ...FastCrawlLoader_flowState
                ...FlowStatePoller_flowState
                id
                flowKey
                previousState
                current {
                  state
                  percentComplete
                  errorMessage
                  id
                }
                pending {
                  state
                  percentComplete
                  errorMessage
                  id
                }
              }
            }
          }
          primaryTeam {
            __typename
            ... on Team {
              teamId
              teamName
            }
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          userTeams {
            __typename
            ... on TeamList {
              list {
                teamId
                teamCalendarId
                userSettings {
                  __typename
                  ... on TeamUserSettings {
                    useTeamCalendar
                  }
                  ... on Node {
                    __isNode: __typename
                    id
                  }
                }
                settings {
                  __typename
                  ... on TeamSettings {
                    manageTeamCalendar
                  }
                  ... on Node {
                    __isNode: __typename
                    id
                  }
                }
                id
              }
            }
          }
          orgAccountingPeriod {
            __typename
            ... on OrgAccountingPeriod {
              periodRange {
                minDate
                maxDate
              }
              quotaMax
              quotaUsed
              enforcementState
            }
            ... on GraphEntityError {
              statusCode
              message
            }
          }
          userGoals(first: 1000000) {
            edges {
              node {
                id
                goalId
                name
                isDeleted
                options {
                  specificOptions {
                    __typename
                    ... on GoalWithinDayOptions {
                      minTimeSlot
                      maxTimeSlot
                      minimumDuration
                      idealDuration
                    }
                    ... on GoalWithinWeekOptions {
                      maxMinutesPerBlock
                    }
                  }
                }
              }
            }
          }
          ...EventColoringSettings_org
          eventColoringSettingsErrorable {
            __typename
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on EventColoringSettings {
              eventCategoryColorings {
                ...EventCategoryColoring_eventCategoryColoring
                googleColorKey
                eventCategory
                active
                isUserSet
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
        }
      }
    }
  }
}

fragment EventCategoryColoring_eventCategoryColoring on EventCategoryColoring {
  eventCategory
  googleColorKey
  active
  isUserSet
}

fragment EventCategoryColoring_org on Org {
  id
  primaryOrgCalendar
}

fragment EventColoringSettings_org on Org {
  ...EventCategoryColoring_org
  id
  experiments
  primaryOrgCalendar
  eventColoringSettingsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on EventColoringSettings {
      eventCategoryColorings {
        ...EventCategoryColoring_eventCategoryColoring
        googleColorKey
        eventCategory
        active
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment FastCrawlErrorCard_org on Org {
  id
}

fragment FastCrawlLoader_flowState on FlowState {
  id
  flowKey
  current {
    state
    percentComplete
    errorMessage
    id
  }
  pending {
    state
    percentComplete
    errorMessage
    id
  }
}

fragment FeedScheduler_org on Org {
  id
  domains
  primaryOrgEmail
  experiments
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      shadowCalendarId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment FeedScheduler_user on User {
  id
  emails
  createdTime
  ...TutorialFeedScheduler_user
  chromeExtensionFlagsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Flags {
      flags
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  dataSources(first: 1000000) {
    edges {
      node {
        id
        name
        calendarIds
        syncTargets {
          emailAddress
          calendarId
        }
        state
        type
        username
      }
    }
  }
}

fragment FlowStatePoller_flowState on FlowState {
  id
  flowKey
  previousState
  current {
    state
    percentComplete
    errorMessage
    id
  }
  pending {
    state
    percentComplete
    errorMessage
    id
  }
}

fragment FreemiumStatusCallout_org on Org {
  id
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment LoginBtn_viewer on Viewer {
  user {
    orgs(first: 1000000) {
      edges {
        node {
          id
          experiments
        }
      }
    }
    id
  }
}

fragment OnboardingNUXRenderer_org on Org {
  id
  experiments
  primaryOrgCalendar
}

fragment OrganizerAutopilotPausedFreemiumCallout_org on Org {
  id
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment PlanStatusRefetch_org on Org {
  id
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      featureStates {
        quotaStatusBanner
        quotaAutopilotStatusCallout
        mixedFreemiumOrgUIState {
          quotaStatusBanner
          autopilotPaused
          moveRangesEnabled
          paymentStatusBadge {
            text
            type
          }
        }
        meetingReliefSettingVisibility
      }
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
            type
            productType
          }
        }
        userMetadata {
          person {
            primaryCalendarId
            id
          }
          trialMetadata {
            trialEndDate
            timeZone
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment PricingDialog_org on Org {
  id
  experiments
}

fragment TutorialBox_user on User {
  chromeExtensionFlagsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Flags {
      ...TutorialTeamHealth_flags
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment TutorialFeedScheduler_user on User {
  createdTime
  chromeExtensionFlagsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Flags {
      flags
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment TutorialTeamHealth_flags on Flags {
  flags
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalImageUrl",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            (v9 /*: any*/),
            (v10 /*: any*/)
        ],
        "storageKey": null
    } as any, v12 = {
        "kind": "InlineFragment",
        "selections": [
            (v1 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v14 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/),
            (v13 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v15 = {
        "kind": "InlineFragment",
        "selections": [
            (v13 /*: any*/),
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quotaStatusBanner",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v21 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetCalendarId",
            "storageKey": null
        } as any,
        (v1 /*: any*/)
    ], v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdTime",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v25 = [
        (v24 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any,
        (v1 /*: any*/)
    ], v26 = {
        "alias": null,
        "args": (v0 /*: any*/),
        "concreteType": "FlowStateConnection",
        "kind": "LinkedField",
        "name": "flowStates",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flowKey",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "current",
                                "plural": false,
                                "selections": (v25 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "pending",
                                "plural": false,
                                "selections": (v25 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousState",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "flowStates(first:1000000)"
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any, v28 = [
        (v2 /*: any*/),
        (v15 /*: any*/),
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flags",
                    "storageKey": null
                }
            ],
            "type": "Flags",
            "abstractKey": null
        } as any,
        (v12 /*: any*/)
    ], v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "linkName",
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "ChromeWrapperRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ChromeWrapper_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ChromeWrapperRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personForUserErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "userId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isUser",
                                                                            "storageKey": null
                                                                        },
                                                                        (v11 /*: any*/)
                                                                    ],
                                                                    "type": "Person",
                                                                    "abstractKey": null
                                                                },
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackAccountsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackAccount",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "slackTeamId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "slackUserId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamDisplayName",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackAccountList",
                                                                    "abstractKey": null
                                                                },
                                                                (v14 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventColoringSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v15 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EventCategoryColoring",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventCategoryColorings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "googleColorKey",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "eventCategory",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "active",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isUserSet",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventColoringSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "primaryTeam",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v16 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "teamName",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Team",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/),
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "featureGrid",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PaymentStateMetadata",
                                                                            "kind": "LinkedField",
                                                                            "name": "stateMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PrimaryBillingGroupMetadata",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "primaryBillingGroupMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "PaymentSubscription",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "subscription",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v1 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "productType",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "UserMetadata",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "userMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "OrgPerson",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "person",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "primaryCalendarId",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v1 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TrialMetadata",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "trialMetadata",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "trialEndDate",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v18 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "FeatureStates",
                                                                            "kind": "LinkedField",
                                                                            "name": "featureStates",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v19 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "quotaAutopilotStatusCallout",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "MixedFreemiumOrgUiState",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "mixedFreemiumOrgUIState",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v19 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "autopilotPaused",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "moveRangesEnabled",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "PaymentStatusBadge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "paymentStatusBadge",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "text",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v17 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "meetingReliefSettingVisibility",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "FeatureGrid",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "shadowCalendarSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "shadowCalendarId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "enabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeIdealMinutesPerWeek",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeSyncEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeSyncAll",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ShadowCalendarSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "calendarIds",
                                                                    "value": []
                                                                }
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personsByCalendarIdsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Person",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                (v5 /*: any*/),
                                                                                (v11 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isOutsideOrg",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "PersonList",
                                                                    "abstractKey": null
                                                                },
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": "personsByCalendarIdsErrorable(calendarIds:[])"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "orgAccountingPeriod",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DateRange",
                                                                            "kind": "LinkedField",
                                                                            "name": "periodRange",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "minDate",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "maxDate",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "quotaMax",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "quotaUsed",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "enforcementState",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgAccountingPeriod",
                                                                    "abstractKey": null
                                                                },
                                                                (v14 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "resolveOverrides",
                                                                    "value": false
                                                                }
                                                            ],
                                                            "concreteType": "UserWorkingHours",
                                                            "kind": "LinkedField",
                                                            "name": "userWorkingHours",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingHours",
                                                                    "kind": "LinkedField",
                                                                    "name": "workingHours",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DaySetting",
                                                                            "kind": "LinkedField",
                                                                            "name": "daySettings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "day",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v20 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DayOverride",
                                                                            "kind": "LinkedField",
                                                                            "name": "dayOverrides",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "date",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v20 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v1 /*: any*/)
                                                            ],
                                                            "storageKey": "userWorkingHours(resolveOverrides:false)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "nextDefragTime",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "millis",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "DefragTime",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v0 /*: any*/),
                                                            "concreteType": "SuggestedOrgInviteConnection",
                                                            "kind": "LinkedField",
                                                            "name": "suggestedInvites",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "SuggestedOrgInviteEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SuggestedOrgInvite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": (v21 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "suggestedInvites(first:1000000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v0 /*: any*/),
                                                            "concreteType": "OrgInviteConnection",
                                                            "kind": "LinkedField",
                                                            "name": "pendingInvites",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "OrgInviteEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgInvite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": (v21 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "pendingInvites(first:1000000)"
                                                        },
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "crawlTest",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgMeetingHours",
                                                            "kind": "LinkedField",
                                                            "name": "orgMeetingHours",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingHours",
                                                                    "kind": "LinkedField",
                                                                    "name": "workingHours",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v18 /*: any*/),
                                                                        (v1 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v1 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v26 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userTeams",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Team",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v16 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamCalendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "userSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v2 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "useTeamCalendar",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "TeamUserSettings",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v12 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "settings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v2 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "manageTeamCalendar",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "TeamSettings",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v12 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v1 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v0 /*: any*/),
                                                            "concreteType": "GoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "userGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "GoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Goal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "goalId",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v22 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isDeleted",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "GoalOptions",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "specificOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v2 /*: any*/),
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "minTimeSlot",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "maxTimeSlot",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "minimumDuration",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "idealDuration",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "GoalWithinDayOptions",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "maxMinutesPerBlock",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "GoalWithinWeekOptions",
                                                                                                    "abstractKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "userGoals(first:1000000)"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v1 /*: any*/),
                                (v6 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "DataSourceConnection",
                                    "kind": "LinkedField",
                                    "name": "dataSources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DataSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DataSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CrawlTarget",
                                                            "kind": "LinkedField",
                                                            "name": "syncTargets",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "emailAddress",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "username",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "dataSources(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "chromeExtensionFlagsErrorable",
                                    "plural": false,
                                    "selections": (v28 /*: any*/),
                                    "storageKey": null
                                },
                                (v23 /*: any*/),
                                (v27 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "linkNameErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v14 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v29 /*: any*/)
                                            ],
                                            "type": "LinkName",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SchedulingLink",
                                    "kind": "LinkedField",
                                    "name": "schedulingLinks",
                                    "plural": true,
                                    "selections": [
                                        (v29 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "linkUrl",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MeetingSettings",
                                            "kind": "LinkedField",
                                            "name": "meetingSettings",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TimingSettings",
                                                    "kind": "LinkedField",
                                                    "name": "timingSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "durationMinutes",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "LinkTimeRange",
                                                            "kind": "LinkedField",
                                                            "name": "timeRange",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "windowSizeDays",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v22 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "slug",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isActive",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "availabilityType",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Urn",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                        (v30 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Urn",
                                            "kind": "LinkedField",
                                            "name": "scope",
                                            "plural": false,
                                            "selections": [
                                                (v17 /*: any*/),
                                                (v30 /*: any*/),
                                                (v1 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "webAppFlagsErrorable",
                                    "plural": false,
                                    "selections": (v28 /*: any*/),
                                    "storageKey": null
                                },
                                (v26 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v1 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "869c63f264bc9b03b313f8f9e4aee6e4",
            "id": null,
            "metadata": {},
            "name": "ChromeWrapperRendererQuery",
            "operationKind": "query",
            "text": "query ChromeWrapperRendererQuery {\n  viewer {\n    ...ChromeWrapper_viewer\n    id\n  }\n}\n\nfragment AutopilotFlexibility_org on Org {\n  userWorkingHours(resolveOverrides: false) {\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AutopilotForm_org on Org {\n  ...AutopilotFlexibility_org\n  ...OrganizerAutopilotPausedFreemiumCallout_org\n  id\n  experiments\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment ChromeCreateEvent_org_2evVr4 on Org {\n  ...AutopilotForm_org\n  id\n  domains\n  primaryOrgCalendar\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isOutsideOrg\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment ChromeLogin_viewer on Viewer {\n  ...LoginBtn_viewer\n  user {\n    id\n  }\n}\n\nfragment ChromeMenuDrawer_viewer on Viewer {\n  user {\n    id\n    emails\n    givenName\n    familyName\n    externalImageUrl\n    dataSources(first: 1000000) {\n      edges {\n        node {\n          id\n          status\n          name\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          domains\n          personForUserErrorable {\n            __typename\n            ... on GraphEntityError {\n              message\n            }\n            ... on Person {\n              id\n              primaryEmail\n              emails\n              isYou\n              userId\n              isUser\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          slackAccountsErrorable {\n            __typename\n            ... on SlackAccountList {\n              list {\n                id\n                slackTeamId\n                slackUserId\n                teamDisplayName\n              }\n            }\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n          }\n          eventColoringSettingsErrorable {\n            __typename\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on EventColoringSettings {\n              eventCategoryColorings {\n                googleColorKey\n                eventCategory\n                active\n                isUserSet\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          primaryTeam {\n            __typename\n            ... on Team {\n              teamId\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          featureGrid {\n            __typename\n            ... on FeatureGrid {\n              stateMetadata {\n                primaryBillingGroupMetadata {\n                  subscription {\n                    id\n                    type\n                    productType\n                  }\n                }\n              }\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ChromePersonalCalendar_org on Org {\n  id\n  domains\n}\n\nfragment ChromePersonalCalendar_user on User {\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        state\n        type\n        name\n        syncTargets {\n          emailAddress\n          calendarId\n        }\n      }\n    }\n  }\n}\n\nfragment ChromeWrapper_viewer on Viewer {\n  ...ChromeLogin_viewer\n  ...ChromeMenuDrawer_viewer\n  user {\n    ...ChromePersonalCalendar_user\n    ...TutorialBox_user\n    ...FeedScheduler_user\n    id\n    status\n    emails\n    givenName\n    familyName\n    createdTime\n    linkNameErrorable {\n      __typename\n      ... on GraphEntityError {\n        message\n        statusCode\n      }\n      ... on LinkName {\n        __typename\n        linkName\n      }\n    }\n    schedulingLinks {\n      linkName\n      linkUrl\n      meetingSettings {\n        id\n        timingSettings {\n          durationMinutes\n          timeRange {\n            windowSizeDays\n          }\n        }\n        name\n        slug\n        isActive\n        availabilityType\n      }\n    }\n    members {\n      value\n      scope {\n        type\n        value\n        id\n      }\n      id\n    }\n    webAppFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    chromeExtensionFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          ...FastCrawlLoader_flowState\n          ...FlowStatePoller_flowState\n          id\n          flowKey\n          previousState\n          current {\n            state\n            percentComplete\n            errorMessage\n            id\n          }\n          pending {\n            state\n            percentComplete\n            errorMessage\n            id\n          }\n        }\n      }\n    }\n    dataSources(first: 1000000) {\n      edges {\n        node {\n          id\n          state\n          type\n          name\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          ...OnboardingNUXRenderer_org\n          ...ChromePersonalCalendar_org\n          ...FastCrawlErrorCard_org\n          ...FeedScheduler_org\n          ...PricingDialog_org\n          ...FreemiumStatusCallout_org\n          ...ChromeCreateEvent_org_2evVr4\n          ...PlanStatusRefetch_org\n          id\n          name\n          domains\n          createdTime\n          crawlTest\n          featureGrid {\n            __typename\n            ... on FeatureGrid {\n              stateMetadata {\n                userMetadata {\n                  person {\n                    primaryCalendarId\n                    id\n                  }\n                  trialMetadata {\n                    trialEndDate\n                    timeZone\n                  }\n                }\n              }\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n          }\n          experiments\n          primaryOrgEmail\n          primaryOrgCalendar\n          userWorkingHours(resolveOverrides: false) {\n            workingHours {\n              id\n              type\n              timeZone\n              daySettings {\n                day\n                setting {\n                  minSlot\n                  maxSlot\n                  excludedSlots\n                }\n              }\n              dayOverrides {\n                date\n                setting {\n                  minSlot\n                  maxSlot\n                  excludedSlots\n                }\n              }\n            }\n            id\n          }\n          orgMeetingHours {\n            workingHours {\n              timeZone\n              id\n            }\n            id\n          }\n          shadowCalendarSettingsErrorable {\n            __typename\n            ... on ShadowCalendarSettings {\n              enabled\n              shadowCalendarId\n              focusTimeIdealMinutesPerWeek\n              focusTimeSyncEnabled\n              focusTimeSyncAll\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          flowStates(first: 1000000) {\n            edges {\n              node {\n                ...FastCrawlLoader_flowState\n                ...FlowStatePoller_flowState\n                id\n                flowKey\n                previousState\n                current {\n                  state\n                  percentComplete\n                  errorMessage\n                  id\n                }\n                pending {\n                  state\n                  percentComplete\n                  errorMessage\n                  id\n                }\n              }\n            }\n          }\n          primaryTeam {\n            __typename\n            ... on Team {\n              teamId\n              teamName\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          userTeams {\n            __typename\n            ... on TeamList {\n              list {\n                teamId\n                teamCalendarId\n                userSettings {\n                  __typename\n                  ... on TeamUserSettings {\n                    useTeamCalendar\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n                settings {\n                  __typename\n                  ... on TeamSettings {\n                    manageTeamCalendar\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n          orgAccountingPeriod {\n            __typename\n            ... on OrgAccountingPeriod {\n              periodRange {\n                minDate\n                maxDate\n              }\n              quotaMax\n              quotaUsed\n              enforcementState\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n          }\n          userGoals(first: 1000000) {\n            edges {\n              node {\n                id\n                goalId\n                name\n                isDeleted\n                options {\n                  specificOptions {\n                    __typename\n                    ... on GoalWithinDayOptions {\n                      minTimeSlot\n                      maxTimeSlot\n                      minimumDuration\n                      idealDuration\n                    }\n                    ... on GoalWithinWeekOptions {\n                      maxMinutesPerBlock\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ...EventColoringSettings_org\n          eventColoringSettingsErrorable {\n            __typename\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on EventColoringSettings {\n              eventCategoryColorings {\n                ...EventCategoryColoring_eventCategoryColoring\n                googleColorKey\n                eventCategory\n                active\n                isUserSet\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventCategoryColoring_eventCategoryColoring on EventCategoryColoring {\n  eventCategory\n  googleColorKey\n  active\n  isUserSet\n}\n\nfragment EventCategoryColoring_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventColoringSettings_org on Org {\n  ...EventCategoryColoring_org\n  id\n  experiments\n  primaryOrgCalendar\n  eventColoringSettingsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        ...EventCategoryColoring_eventCategoryColoring\n        googleColorKey\n        eventCategory\n        active\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment FastCrawlErrorCard_org on Org {\n  id\n}\n\nfragment FastCrawlLoader_flowState on FlowState {\n  id\n  flowKey\n  current {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n  pending {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n}\n\nfragment FeedScheduler_org on Org {\n  id\n  domains\n  primaryOrgEmail\n  experiments\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      shadowCalendarId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment FeedScheduler_user on User {\n  id\n  emails\n  createdTime\n  ...TutorialFeedScheduler_user\n  chromeExtensionFlagsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Flags {\n      flags\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        name\n        calendarIds\n        syncTargets {\n          emailAddress\n          calendarId\n        }\n        state\n        type\n        username\n      }\n    }\n  }\n}\n\nfragment FlowStatePoller_flowState on FlowState {\n  id\n  flowKey\n  previousState\n  current {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n  pending {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n}\n\nfragment FreemiumStatusCallout_org on Org {\n  id\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment LoginBtn_viewer on Viewer {\n  user {\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          experiments\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment OnboardingNUXRenderer_org on Org {\n  id\n  experiments\n  primaryOrgCalendar\n}\n\nfragment OrganizerAutopilotPausedFreemiumCallout_org on Org {\n  id\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment PlanStatusRefetch_org on Org {\n  id\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      featureStates {\n        quotaStatusBanner\n        quotaAutopilotStatusCallout\n        mixedFreemiumOrgUIState {\n          quotaStatusBanner\n          autopilotPaused\n          moveRangesEnabled\n          paymentStatusBadge {\n            text\n            type\n          }\n        }\n        meetingReliefSettingVisibility\n      }\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n            type\n            productType\n          }\n        }\n        userMetadata {\n          person {\n            primaryCalendarId\n            id\n          }\n          trialMetadata {\n            trialEndDate\n            timeZone\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment PricingDialog_org on Org {\n  id\n  experiments\n}\n\nfragment TutorialBox_user on User {\n  chromeExtensionFlagsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Flags {\n      ...TutorialTeamHealth_flags\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment TutorialFeedScheduler_user on User {\n  createdTime\n  chromeExtensionFlagsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Flags {\n      flags\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment TutorialTeamHealth_flags on Flags {\n  flags\n}\n"
        }
    } as any;
})();
(node as any).hash = '931ae944703dd09a9496a64a867dcfbc';
export default node;
